
import { ColumnDef } from "@tanstack/react-table";
import { Badge, Checkbox, fmt } from "visuais";

export const inclusaoFaturasColumns = ({ faturas, setFaturas }: { faturas: any[], setFaturas: any }) : ColumnDef<any>[] => [
  {
    id: "select",
    header: () => (
      <Checkbox
        checked={faturas.every(f => f.checked)}
        onCheckedChange={value => setFaturas(faturas.map(f => ({ ...f, checked: !!value })))}
        aria-label="Selecionar todas linhas"
      />
    ),
    cell: ({ row }) => {
      const faturaAtual = row.original
      const makeKey = (f: any) => String(
        f.R_E_C_N_O_ ?? `${f.F1_FILIAL}-${f.F1_DOC}-${f.F1_SERIE}-${f.F1_DOC}-${f.Z10_CHAVE}`
      )
      const keyAtual = makeKey(faturaAtual)
      const faturaNoStore = faturas.find((f) => makeKey(f) === keyAtual) || faturaAtual
      return (
        <Checkbox
          checked={!!faturaNoStore.checked}
          onCheckedChange={value => {
            const nova = faturas.map((f) =>
              makeKey(f) === keyAtual ? { ...f, checked: !!value } : f
            )
            setFaturas(nova)
          }}
          aria-label={`Selecionar linha ${row.index + 1}`}
        />
      )
    },
    enableSorting: false,
    size: 40,
  },
  {
    accessorKey: "F1_FILIAL",
    header: "Filial",
  },
  {
    accessorKey: "F1_DOC",
    header: "NF",
  },
  {
    accessorKey: "F1_SERIE",
    header: "Série",
  },
  {
    accessorKey: "F1_EMISSAO",
    header: "Emissão",
    cell: ({ getValue }) => fmt.dates.BR(getValue() as string),
  },
  {
    accessorKey: "A2_NOME",
    header: "Fornecedor",
    cell: ({ getValue, row }) => {
      const nome = String(getValue() ?? "");
      const cgc = row.original.A2_CGC ?? "";
      const nomeLimitado = nome.length > 20 ? nome.slice(0, 60) + "..." : nome;
      return `${nomeLimitado} (CNPJ: ${cgc})`;
    },
  },
  // {
  //   accessorKey: "F1_STATUS",
  //   header: "Status",
  //   cell: ({ getValue }) => {
  //     const status = getValue();
  //     console.log("Status:", status); // 👈 aqui
  //     return (
  //       <Badge
  //         variant="outline"
  //         className={
  //           status === "A"
  //             ? "text-lime-600 border dark:text-lime-400"
  //             : "text-amber-600 border dark:text-amber-400"
  //         }
  //       >
  //         {status === "A" ? "Classificada" : "Pendente"}
  //       </Badge>
  //     );
  //   },
  // },
  { 
    accessorKey: "F1_STATUS", 
    header: "Status", 
    cell: ({ getValue }) => ( 
      <Badge 
        variant="outline" 
        className="text-lime-600 border dark:text-lime-400"> 
          Classificada
      </Badge> 
    ), 
  },
  {
    accessorKey: "VALOR",
    header: "Valor",
    cell: ({ getValue }) => Number(getValue()).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
  },
];
